








































import Popup from '@/views/organisms/Popup.vue'
import BlueButton from '@/views/atoms/BlueButton.vue'
import ApiClient from '@/common/api'
import store from '@/store'
import TextBox from '@/views/atoms/TextBox.vue'
import ErrorLabel from '@/views/atoms/ErrorLabel.vue'
import PopupComfirmSave from '@/views/template/PopupComfirmSave.vue'
import Global from '@/common/global.js'
import SelectBox from '@/views/atoms/SelectBox.vue'
import TextDatePicker from '@/views/molecules/TextDatePicker.vue'
import PopupComfirmEdit from '@/views/template/PopupComfirmEdit.vue'
import moment from 'moment'
import TextArea from '@/views/atoms/TextArea.vue'

export default
  components: {
    Popup
    BlueButton
    TextBox
    ErrorLabel
    PopupComfirmSave
    SelectBox
    TextDatePicker
    PopupComfirmEdit
    TextArea
  }

  props:
    id:
      type: String
      default: ''
    date:
      type: String
      default: ''
    month:
      type: String
      default: ''
    containerType:
      type: String
      default: ''
    capacity:
      type: String
      default: ''
    status:
      type: String
      default: ''
    disabled:
      type: Boolean
      default: false

  watch: {
    disabled: (v) ->
      @disable = v
  }

  data: () ->
    isShowPopup: {}
    containerTypeList: Global.containerTypeUser()
    capacityList: Global.capacity()
    showEditButton: true
    disable: false

  created: () ->
    store.dispatch('setErrors', [])
    @showEditButton = moment(@date).isAfter(@month, 'day')
    @disable = @disabled
  methods: {
    close_popup: (e) ->
      @$emit('close_popup')
    save_click: () ->
      @closePopup('save')
      @closePopup('edit')
      @disable = true
      @$emit('click')
      @disable = false
    showPopup: (property) ->
      @$set(@isShowPopup, property, true)
    closePopup: (property) ->
      @$set(@isShowPopup, property, false)
  }
